// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"7450":"5eb3df8f7355d6c5","7562":"5f70cfbccffe211e"}[chunkId] + ".css";
};